import React, { FC } from "react";
import Link from "next/link";
import Image from "next/image";
import Visa from "@/assets/icons/visa.svg";
import Master from "@/assets/icons/mastercard.svg";
import Amex from "@/assets/icons/amex.svg";
import { useRouter } from "next/router";
interface FooterProps {}

const Footer: FC<FooterProps> = () => {
  const router = useRouter();
  const isLoginPage = router.pathname === "/signin";

  return (
    !isLoginPage && (
      <footer className="flex flex-col p-4 pb-8 items-center mt-auto">
        <div className="flex flex-col gap-2 max-w-6xl w-full md:items-start items-center">
          <div className="flex gap-4 md:flex-nowrap flex-wrap justify-center">
            <p className="text-[#333943] text-xs font-normal leading-4 ">copyright &copy; Tripstick DMCC </p>

            <div className="flex gap-4">
              <Link href="/terms-and-conditions" className="text-[#333943] text-xs font-normal leading-4 ">
                TERMS & CONDITIONS
              </Link>

              <Link href="/privacy" className="text-[#333943] text-xs font-normal leading-4 ">
                PRIVACY & COOKIES
              </Link>
            </div>
          </div>
          <div className="flex gap-x-2">
            <p>{Visa && <Image src={Visa} alt="visa logo" />}</p>
            <p>{Master && <Image src={Master} alt="mastercard logo" />}</p>
            <p>{Amex && <Image src={Amex} alt="Amex logo" />}</p>
          </div>
        </div>
      </footer>
    )
  );
};

export default Footer;
